import { render, staticRenderFns } from "./corpus.vue?vue&type=template&id=3edb3bae&scoped=true&"
import script from "./corpus.vue?vue&type=script&lang=js&"
export * from "./corpus.vue?vue&type=script&lang=js&"
import style0 from "./corpus.vue?vue&type=style&index=0&id=3edb3bae&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb3bae",
  null
  
)

export default component.exports